// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DataCell {
  text-align: center;
}
.card_wrapper {
  display: flex;
  justify-content: space-evenly;
  flex-wrap: wrap;
  gap: 20px;
}
.card_section {
  border-radius: 8px;
  background-color: #ffffff;
  padding: 20px 10px;
  color: #004aaf;
  box-shadow: rgba(116, 116, 165, 0.2) 0px 7px 29px 0px;
  transition: 0.3s;
  width: 250px;
  display: flex;
  align-items: center;
  gap: 20px;
  flex-direction: column;
  height: auto;
}
.gen_sub_title {
  height: 1px;
  background: #00000030;
  width: 75%;
  margin: 0 auto;
}

.contact_tile {
  background: white;
  padding: 30px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: rgba(116, 116, 165, 0.2) 0px 7px 29px 0px;
  flex-wrap: wrap;
}
.quick_action {
  background-color: white;
  width: 300px;
  padding: 30px;
  box-shadow: rgba(116, 116, 165, 0.2) 0px 7px 29px 0px;
}
.renewal_link_div {
  display: flex;
  align-items: center;
  gap: 10px;
  height: 100%;
}
.tile_wrapper {
  display: flex;
  justify-content: space-evenly;
  flex-wrap: wrap;
  gap: 30px;
}

.renewal_link_modal {
  flex-direction: column;
  gap: 5px;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.modal_wrapper_for_quick_action {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 111;
  justify-content: center;
  align-items: center;
  display: flex;
  overflow: hidden;
}
.quick_action_modal {
  width: 90%;
  max-width: 400px;
  background-color: white;
  box-shadow: rgba(116, 116, 165, 0.2) 0px 7px 29px 0px;
  padding: 20px;
}
.title_qa {
  font-size: 25px;
  font-weight: 600;
}

@media screen and (max-width: 900px) {
  .contact_tile {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Customer/LandingPage/index.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,6BAA6B;EAC7B,eAAe;EACf,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,qDAAqD;EACrD,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,WAAW;EACX,qBAAqB;EACrB,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qDAAqD;EACrD,eAAe;AACjB;AACA;EACE,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,qDAAqD;AACvD;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;AACA;EACE,aAAa;EACb,6BAA6B;EAC7B,eAAe;EACf,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,gBAAgB;EAChB,uBAAuB;EACvB,qDAAqD;EACrD,aAAa;AACf;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":[".DataCell {\r\n  text-align: center;\r\n}\r\n.card_wrapper {\r\n  display: flex;\r\n  justify-content: space-evenly;\r\n  flex-wrap: wrap;\r\n  gap: 20px;\r\n}\r\n.card_section {\r\n  border-radius: 8px;\r\n  background-color: #ffffff;\r\n  padding: 20px 10px;\r\n  color: #004aaf;\r\n  box-shadow: rgba(116, 116, 165, 0.2) 0px 7px 29px 0px;\r\n  transition: 0.3s;\r\n  width: 250px;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 20px;\r\n  flex-direction: column;\r\n  height: auto;\r\n}\r\n.gen_sub_title {\r\n  height: 1px;\r\n  background: #00000030;\r\n  width: 75%;\r\n  margin: 0 auto;\r\n}\r\n\r\n.contact_tile {\r\n  background: white;\r\n  padding: 30px;\r\n  margin: 0 auto;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  box-shadow: rgba(116, 116, 165, 0.2) 0px 7px 29px 0px;\r\n  flex-wrap: wrap;\r\n}\r\n.quick_action {\r\n  background-color: white;\r\n  width: 300px;\r\n  padding: 30px;\r\n  box-shadow: rgba(116, 116, 165, 0.2) 0px 7px 29px 0px;\r\n}\r\n.renewal_link_div {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  height: 100%;\r\n}\r\n.tile_wrapper {\r\n  display: flex;\r\n  justify-content: space-evenly;\r\n  flex-wrap: wrap;\r\n  gap: 30px;\r\n}\r\n\r\n.renewal_link_modal {\r\n  flex-direction: column;\r\n  gap: 5px;\r\n  align-items: center;\r\n  justify-content: center;\r\n  text-align: center;\r\n}\r\n\r\n.modal_wrapper_for_quick_action {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  bottom: 0;\r\n  right: 0;\r\n  z-index: 111;\r\n  justify-content: center;\r\n  align-items: center;\r\n  display: flex;\r\n  overflow: hidden;\r\n}\r\n.quick_action_modal {\r\n  width: 90%;\r\n  max-width: 400px;\r\n  background-color: white;\r\n  box-shadow: rgba(116, 116, 165, 0.2) 0px 7px 29px 0px;\r\n  padding: 20px;\r\n}\r\n.title_qa {\r\n  font-size: 25px;\r\n  font-weight: 600;\r\n}\r\n\r\n@media screen and (max-width: 900px) {\r\n  .contact_tile {\r\n    display: none;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
